export default {
  event: {
    events: 'Events',
    societe: 'Company',
    contact: 'Contact for the event',
    list_of_events: 'List of events',
    new_event: 'New Event',
    participer: 'Visible',
    name_of_the_event: 'Name of the event',
    date: 'Date',
    country: 'Country',
    creator: 'Creator',
    status: 'Status',
    simple_extraction: 'Simple Extraction',
    full_extraction: 'Full Extraction',
    upload_csv: 'Upload CSV',
    add_exhibitors: 'Add exhibitors',
    find_an_exhibitors: 'Find an exhibitor',
    list_of_exhibitors: 'List of Exhibitors',
    export_exhibitors: 'Export exhibitor',
    event_informations: 'Event informations',
    start_event: 'Date of the start of the event',
    year_of_the_event: 'Year of the event',
    select_year: 'Select year',
    end_event: 'Date of the end of the event',
    city_of_event: 'City of the event',
    country_of_event: 'Country of the event',
    registration_closing_date: 'Registration closing date',
    showroom_on_event: 'Showroom on this event',
    hub_on_event: 'Hub on this event',
    animation_on_event: 'animation on this event',
    showroom_informations: 'Showroom informations',
    hub_informations: 'Hub informations',
    animation_informations: 'Animation informations',
    questions: 'Questions',
    animation_title: 'Animation title',
    animation_description: 'Animation description',
    thematic_title: 'Thématiques title',
    thematic_description: 'Thématiques description',
    event_color: 'Color',
    catalog_products_limit: 'Maximum number of e-catalogue products',
    thematic_enabled: 'Enable Thématiques',
    thematic_selection_count: 'Number of choice selections',
    number_of_products: 'Number of products',
    select_number_of_products: 'Select number of products',
    sample_informations: 'Samples informations',
    numbers_of_sample_send: 'Number of samples to send',
    address_to_send_semple: 'Address to send samples',
    limit_date_to_receive_sample: 'Limit date to receive samples',
    registration: 'Registration',
    event_information: 'Event information',
    export_profile: 'Export Profile',
    questionnaire: 'Questionnaire',
    trade_name: 'Trade Name',
    trade_name_subtitle:
      'As you wish it to appear on our various communication materials (stand, plan, catalogue, etc.).',
    trade_name_local: 'Trade Name (local)',
    trade_name_local_subtitle:
      'Non-Latin characters: Chinese, Japanese, Korean, etc.',
    trade_name_local_placeholder:
      'Trade name in local language (non-Latin characters: Chinese, Japanese, Korean, etc.)',
    contact_for_this_event: 'Contact for this event',
    informations_visibles_sur_le_e_catalogue:
      'Information visible in the e-catalogue',
    information_de_la_societe: 'Company Information',
    sur_name: 'Sur name',
    last_name: 'Last name',
    mobile_phone: 'Mobile phone',
    email: 'Email',
    contact_position: 'Contact position',
    your_products: 'Your selection of products',
    your_products_catalog: 'Your selection of products for the e-catalog',
    possibility_of_presenting_up_to_10_references:
      'Possibility of presenting up to {{count}} references',
    select_product: 'Select product',
    add_a_new_product: 'Create a new product',
    save: 'Save',
    save_and_transmit: 'Save and transmit',
    possibility_to_reconnect_and_sequence_the_entry_of_information:
      '*Possibility to reconnect and sequence the entry of information.',
    your_entry_is_finalized_the_elements_can_no_longer_be_modified:
      '**Your entry is finalized, the elements can no longer be modified.',
    date_of_event: 'Date of event',
    add_product_from_catalog: 'Add product from your catalog',
    invite: 'Invite',
    website_title: 'Website title',
    website_informations: 'Website informations',
    header_logo_left: 'Header logo (left)',
    header_logo_left_two: 'Logo n°2 Top left',
    header_logo_right: 'Header logo (right)',
    subtitle_of_the_event: 'Subtitle of the event',
    logo: 'Logo',
    e_catalogue_url: 'E-catalogue URL',
    inviter_par_email: 'Invite by e-mail',
    send_email: 'Send email',
    copy_the_link: 'Copy the link',
    copy_the_link_success: 'The invitation code has been copied successfully',
    invite_with_email: 'Invite with email*',
    import_exhibitor_database: 'Import exhibitor database',
    active: 'Active',
    icon: 'Add the selected product from the catalog',
    dossier: 'Case',
    edit: 'Edit',
    required: 'This field is required',
    number_exhibitors: 'Number of exhibitors registered for this event',
    number_admins: 'Number of admins registered for this event',
    add_exhibitor_to_the_event: 'Add exhibitor to the event',
    company: 'Raison sociale',
    type_of_product: 'Type of product',
    color_of_wine: 'Color of wine',
    grape_varietal: 'Grape variety',
    type_of_growing: 'Type of wine-growing',
    add_exhibitor: 'Add exhibitor',
    search: 'Search',
    add_exhibitor_to_the_event_selection: 'Add selected exhibitors',
    exhibitror_successfilly_updated:
      'Exhibitor information has been successfully updated',
    add_the_least_one_product:
      'Add at least one product to be able to transmit your file',
    loading: 'Loading',
    prepare_csv: 'Prepare csv',
    thematic: 'Thematic',
    thematic_choice: 'Thematic choice No.',
    download_pdf: 'Download PDF',
    ok: 'OK',
    confirmation: 'Confirmation',
    commercial_name: 'Commercial name',
    animation: 'Animation',
    no_product_available: 'No product available',
    showroom_logo: 'Showroom logo',
    no_thematic_found: 'No thematic found',
    limit: 'limit',
    preview: 'Preview',
    exhibitor_list: 'Exhibitor List',
    product_list: 'Product List',
    offer_page: 'Offer Page',
    color: 'Color 1',
    second_color: 'Color 2',
    facturation_code: 'Facturation code',
    category: 'Category',
    select_category: 'Select category',
    all_categories: 'All categories',
    offers: 'Offers',
    offer_name: 'Offer name',
    price: 'Price',
    price_ht: 'Price excl. tax',
    quantity: 'Quantity',
    total_ht: 'Total excl. tax',
    connector_admin: 'Connector Admin',
    add: 'Add',
    add_admin: 'Add Admin',
    add_moderator: 'Add Moderator',
    add_moderator_to_the_event: 'Add moderator to the event',
    number_moderators: 'Moderators registered for this event',
    no_moderator_found: 'No moderator found',
    moderator_added_to_event: 'Moderator added to the event',
    moderator_removed_from_event: 'Moderator removed from the event',
    invite_to_admin: 'Invite to Admin',
    add_admin_to_the_event: 'Add admin to the event',
    add_admin_to_the_event_selection: 'Add selected admins',
    already_added: 'Already added',
    remove_admin: 'Remove',
    no_admin_found: 'No admin found',
    admin_added_to_event: 'Admin added to the event',
    admin_removed_from_event: 'Admin removed from the event',
    connector: 'Connector',
  },
};
